<template>
  <div>
    <v-card
      v-if="quoteItems && !isEviction"
      :class="breakPointChange"
      class="ml-auto px-5 pt-5 pb-1 mt-6 priceCard body-2"
      elevation="0"
    >

      <!-- subtotal -->
      <v-row v-if="hasSubtotal && !isEviction" no-gutter>
        <v-col class="px-3 pt-0">
          {{ $t('quote.priceTable.subtotal') }}
        </v-col>
        <v-col class="text-right px-3 pt-0">
          {{ formatMoney(quotes.subtotal_by_installments) }}
        </v-col>
      </v-row>
      <!-- subtotal -->

      <!-- discount -->
      <v-row class="grey--text" v-if="hasDiscount" no-gutter>
        <v-col class="px-3 pt-0">
          {{ $t('quote.priceTable.discount') }}
        </v-col>
        <v-col class="text-right px-3 pt-0">
          {{ formatMoney(quoteItems.vendor_discount) }}
        </v-col>
      </v-row>
      <!-- /discount -->

      <!-- FCI -->
      <v-row class="grey--text" v-if="hasFCI && !payWithFci" no-gutter>
        <v-col class="px-3 pt-0">
          {{ $t('quote.priceTable.usedFci') }}
        </v-col>
        <v-col class="text-right px-3 pt-0">
          {{ formatMoney(quoteItems.net_fci) }}
        </v-col>
      </v-row>

      <v-row
        v-if="payWithFci && cashDiscountIsBiggerThanZero && !isQuoteAlreadyPaid"
        class="grey--text"
        no-gutter
      >
        <v-col class="px-3 pt-0">
          {{ $t('quote.priceTable.cashDiscount') }}
        </v-col>
        <v-col class="text-right px-3 pt-0">
          {{ formatMoney(quoteItems.cash_discount) }}
        </v-col>
      </v-row>

      <v-row v-if="payWithFci" no-gutter>
        <v-col class="px-3 pt-0">
          {{ $t('quote.priceTable.total') }}
        </v-col>
        <v-col class="text-right px-3 pt-0">
          {{ formatMoney(quoteItems.net_fci) }}
        </v-col>
      </v-row>
      <!-- /FCI -->

      <!-- total with discounts -->
      <v-row v-if="!payWithFci && !isEviction" no-gutter>
        <v-col class="px-3 pt-0">
          {{ $t('quote.priceTable.total') }}
        </v-col>
        <v-col class="text-right px-3 pt-0">
          {{ formatMoney(quoteItems.total_by_installments) }}
        </v-col>
      </v-row>
      <!-- /total with discounts -->

      <QuotePricesTotal
        v-if="!isQuoteAlreadyPaid"
        :quotes="quotes"
        :quoteItems="quoteItems"
        :isEviction="isEviction"
        :payWithFci="payWithFci"
      />
    </v-card>

    <QuotePaymentMethods
      v-if="isQuoteAlreadyPaid"
      :quotes="quotes"
      :quoteItems="quoteItems"
      :isEviction="isEviction"
      :payWithFci="payWithFci"
      :paymentMethod="paymentMethod"
    />
  </div>
</template>

<script>
import QuotePaymentMethods from '@/views/quote/components/QuotePaymentMethods'
import QuotePricesTotal from  './QuotePricesTotal'

import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'QuotePrices',

  components: {
    QuotePricesTotal,
    QuotePaymentMethods,
  },

  props: {
    quotes: {
      type: Object,
    },

    quoteItems: {
      type: Object,
    },

    appointmentType: {
      type: String,
    },

    isQuoteAlreadyPaid: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    breakPointChange() {
      return !this.$vuetify.breakpoint.mobile && 'mw-400'
    },

    hasSubtotal() {
      return this.quoteItems?.subtotal > 0
    },

    hasFCI() {
      return this.quoteItems?.fci > 0
    },

    hasDiscount() {
      return this.quoteItems?.vendor_discount > 0
    },

    payWithFci() {
      return this.quoteItems ? this.quoteItems?.total == 0 : false
    },

    isEviction() {
      return this.appointmentType === 'EVICTION'
    },

    paymentMethod() {
      return this.quotes?.charge?.installments[0]?.payment_method
    },

    cashDiscountIsBiggerThanZero() {
      return this.quoteItems.cash_discount > 0
    }
  },

  data() {
    return {
      formatMoney: catalogMonetary,
    }
  },
}
</script>

<style scoped>
@media print {
  .priceCard {
    background-color: #e6f9fe;
    -webkit-print-color-adjust: exact;
  }
}

.priceCard {
  background-color: #e6f9fe;
}

.priceCard .body-2 {
  color: #21566e;
}

.priceCard .body-2 {
  opacity: 0.8;
}
</style>
